/* Import defaults */
import Vue from 'vue';

/* Import packages */
import Vuex from 'vuex';
import PersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';

/* Assign defaults */
Vue.use(Vuex);
const ls = new SecureLS({ isCompression: true });

export default new Vuex.Store({
	strict: false,
	plugins: [
		PersistedState({
			key: 'poz.hr',
			// storage: {
			//   getItem: (key) => ls.get(key),
			//   setItem: (key, value) => ls.set(key, value),
			//   removeItem: (key) => ls.remove(key),
			// }
		})
	],
	state: {
		client: null,
		coupon: null,
		paymentType: 'card-payment',
		paymentData: null,
		deliveryData: null,
		orderId: null,
		cart: [],
		wish: [],
		cookies: false,
		loading: false,
		expiration: null,
	},
	mutations: {
		setClient (state, data) {
			state.client = data;
		},
		setCoupon (state, data) {
			state.coupon = data;
		},
		setPaymentType (state, data) {
			state.paymentType = data;
		},
		setPaymentData (state, data) {
			state.paymentData = data;
		},
		setDeliveryData (state, data) {
			state.deliveryData = data;
		},
		setOrderId (state, data) {
			state.orderId = data;
		},
		setCart (state, data) {
			state.cart = data;
		},
		setWish (state, data) {
			state.wish = data;
		},
		setCookies (state, data) {
			state.cookies = data;
		},
		setLoading (state, data) {
			state.loading = data;
		},
		setExpiration (state, data) {
			state.expiration = data;
		},
		resetStoreData (state) {
			state.coupon = null;
			state.paymentType = 'card-payment';
			state.paymentData = null;
			state.deliveryData = null;
			state.orderId = null;
			state.cart = [];
		},
		reinitializeData (state) {
			state.client = null;
			state.coupon = null;
			state.paymentType = 'card-payment';
			state.paymentData = null;
			state.deliveryData = null;
			state.orderId = null;
			state.cart = [];
			state.wish = [];
			state.cookies = false;
			state.loading = false;
			state.expiration = new Date();
		},
		reinitializeApplication (state) {
			state.client = null;
			state.coupon = null;
			state.paymentType = 'card-payment';
			state.paymentData = null;
			state.deliveryData = null;
			state.orderId = null;
			state.cart = [];
			state.wish = [];
			state.cookies = false;
			state.loading = false;
			state.expiration = new Date();
		}
	},
	actions: {
		setClient ({commit}, data) {
			commit('setClient', data);
		},
		setCoupon ({commit}, data) {
			commit('setCoupon', data);
		},
		setPaymentType ({commit}, data) {
			commit('setPaymentType', data);
		},
		setPaymentData ({commit}, data) {
			commit('setPaymentData', data);
		},
		setDeliveryData ({commit}, data) {
			commit('setDeliveryData', data);
		},
		setOrderId ({commit}, data) {
			commit('setOrderId', data);
		},
		setCart ({commit}, data) {
			commit('setCart', data);
		},
		setWish ({commit}, data) {
			commit('setWish', data);
		},
		setCookies ({commit}, data) {
			commit('setCookies', data);
		},
		setLoading ({commit}, data) {
			commit('setLoading', data);
		},
		setExpiration ({commit}, data) {
			commit('setExpiration', data);
		},
		resetStoreData ({commit}) {
			commit('resetStoreData');
		},
		reinitializeData ({commit}) {
			commit('reinitializeData');
		},
		reinitializeApplication ({commit}) {
			commit('reinitializeApplication');
		}
	}
})



// WEBPACK FOOTER //
// ./resources/assets/js/store/Index.js